//关前道具说明界面
var PrepropHelpPanel = xClass("PrepropHelpPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/magicHouse_magicHouse_explain.csb")
})
const RES = [
    "packed/PurpleAmyMagicExplain.pack"
]
PrepropHelpPanel.show = function (loadCb) {
    function onSuccess() {
        loadCb && loadCb()
        PrepropHelpPanel.create()
    }
    preloadWithLoading(RES, onSuccess, function () {
        Toast.make(getText("error.tip.load_res_error"))
        loadCb && loadCb()
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
        loadCb && loadCb()
    })
}
PrepropHelpPanel.prototype.ctor = function () {
    let self = this;
    BasePanel.prototype.ctor.call(self);
    self.popup();

    self.initUI();
}
PrepropHelpPanel.prototype.initUI = function () {
    let self = this
    self.getChildByName("txt1_2").setVisible(false);

    self.unlock_close = self.getChildByName("unlock_close");
    quickBuildUIButton(self.unlock_close, function () {
        self.onClose();
    });

    let title = self.getChildByName("unlock_frame").getChildByName("tittle_lab");
    title.setString(getText("help.start.title"))

    let desc = cc.Label.createWithSystemFont(getText("help.start.text"), "Arial", 26)
    desc.setColor(cc.c4b(188, 119, 67, 255))
    desc.setDimensions(510, 0)
    desc.setPosition(0, 200)
    self.addChild(desc);

    var prepropTable = GamePropPreGame
    for (var i = 1; i < 4; i++) {
        let bg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/com_bg_small.png", cc.rect(20, 20, 20, 20))
        bg.setContentSize(513, 131);
        bg.setPosition(0, 225 - 146 * i);
        self.addChild(bg);

        let propId = prepropTable[i];
        var itemIcon = UIItemBuilder.createPropIcon(propId);
        itemIcon.setPosition(62, 62);
        bg.addChild(itemIcon);

        let itemName = cc.Label.createWithSystemFont(getText("prop.name." + propId), "Arial", 26)
        itemName.setColor(cc.c4b(181, 120, 60, 255))
        itemName.setAnchorPoint(0, 0)
        itemName.setPosition(131, 72)
        bg.addChild(itemName)

        let itemDesc = cc.Label.createWithSystemFont(getText("prop.desc." + propId, table([1, "n", "\n"])), "Arial", 22)
        itemDesc.setDimensions(360, 0)
        itemDesc.setColor(cc.c4b(180, 119, 59, 255))
        itemDesc.setPosition(131, 60)
        itemDesc.setAnchorPoint(0, 1)
        bg.addChild(itemDesc)
    }
}

module.exports = PrepropHelpPanel
